(function () {
    'use strict';
    app.controller('loginController', ['$scope', 'LoginService', '$location', '$cookies', 'AuthenticationService', 'progressBarService', '$rootScope', '$timeout', '$compile', function ($scope, loginService, $location, $cookies, AuthenticationService, progressBarService, $rootScope, $timeout, $compile) {

        $scope.isInvalidIP = false;
        $scope.isError = false;
        $scope.isSuccess = false;

        $scope.loginData = {
            userName: localStorage.getItem("email") == null ? "" : localStorage.getItem("email"),
            password: ""
        };

        if (localStorage.getItem("email")) {
            localStorage.removeItem("email");
        }

        //var authData = AuthenticationService.getTokenInfo();

        $scope.isActiveTab = function (tabIndex) {

            return tabIndex === $scope.currentTab

        };
        $scope.onClickTab = function (tabIndex) {

            $scope.currentTab = tabIndex;
            return tabIndex == $scope.currentTab
        };
        var hideMessage = function () {
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.isModalError = false;
            $scope.isModalSuccess = false;
            $scope.message = '';
        }
        hideMessage();
        $scope.login = function () {
            if ($scope.validateLogin()) {
                progressBarService.showProgressBar();
                loginService.login($scope.loginData.userName, $scope.loginData.password).then(function (response) {

                    if (response != null && response.error != undefined) {

                        $scope.message = response.error_description;

                        $scope.isError = true;
                        $scope.isSuccess = false;
                    }

                    progressBarService.hideProgressBar();
                });
            }
        }

        $scope.validateLogin = function () {

            var returnVal = true;
            if (angular.element("#userName").val() != '') {
                var emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


                if (emailregx.test(angular.element("#userName").val())) {

                    $("#userName").siblings("label").find("span").fadeOut();
                }
                else {

                    if (returnVal) {
                        $("#userName").focus();
                    }
                    $("#userName").siblings("label").find("span").fadeIn();
                    returnVal = false;
                }

            }
            else {

                if (returnVal) {
                    $("#userName").focus();
                }
                $("#userName").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (angular.element("#password").val() != '') {

                $("#password").siblings("label").find("span").fadeOut();
            }
            else {

                if (returnVal) {
                    $("#password").focus();
                }
                $("#password").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (!returnVal) {
                this.LoginForm.$dirty = true;
                this.LoginForm.password.$dirty = true;
                this.LoginForm.userName.$dirty = true;
            }
            return returnVal;
        }

        $scope.cancel = function () {
            $rootScope.$broadcast('reloadCaptcha', {});
            $scope.loginData = {
                userName: "",
                password: ""
            };
            $scope.message = "";
            $(".input-feild-textbox").siblings("label").removeClass("active");

        }

        $scope.setTextboxStyle = function () {
            $(".input-feild-textbox").on("focusin", function () {
                $(this).parent().siblings("label").addClass("active");
                $(this).siblings("label").addClass("active");
            }).focusout(function () {
                if (!$(this).val().trim()) {
                    $(this).parent().siblings("label").removeClass("active");
                    $(this).siblings("label").removeClass("active");
                }
            });
        };

        $scope.setTextboxStyle();

        $rootScope.$on('getInstituteFail', function (event, args) {
            setTimeout(function myfunction() {
                $scope.isInvalidIP = true;
                $scope.$apply();
            }, 500);
        });

        $rootScope.$on('logoutSuccess', function (event, args) {
            setTimeout(function myfunction() {
                $scope.isInvalidIP = true;
                $scope.$apply();
            }, 500);
            //window.location.reload();
        });
    }]);
})();


(function () {
    'use strict';
    app.controller('registerController', ['$scope', 'LoginService', '$location', '$cookies', 'AuthenticationService', 'progressBarService', '$rootScope', '$timeout', '$http', '$routeParams', 'CommonService', function ($scope, loginService, $location, $cookies, AuthenticationService, progressBarService, $rootScope, $timeout, $http, $routeParams, commonService) {

        $scope.isError = false;
        $scope.isSuccess = false;

        $scope.selectAffiliation = function () {
            $('#affiliationName').val('');
            $scope.selectedInstitute.userDefinedAffiliation = "";
            $scope.selectedInstitute.InstitutionId = $scope.profileData.InstitutionId;
            if (!$scope.selectedInstitute.isAffiliationExists) {
                $scope.selectedInstitute.InstitutionName = $scope.profileData.InstitutionName;
            } else {
                if ($scope.profileData.InstitutionName.length == 0) {
                    $scope.selectedInstitute.isAffiliationExists = false
                    //$('#affiliationName').removeAttr('disabled');
                }
                $scope.selectedInstitute.userDefinedAffiliation = $scope.profileData.InstitutionName;
            }

            $('#affiliation').modal('show');
        }

        $scope.loginData = {
            userName: localStorage.getItem("email") == null ? "" : localStorage.getItem("email"),
            password: ""
        };

        if (localStorage.getItem("email")) {
            localStorage.removeItem("email");
        }


        $scope.isInvalidIP = false;

        $scope.InvitedEmail = $routeParams.invitedEmail;

        $scope.profileDataModel = function () {
            $scope.profileData = {
                firstName: "",
                lastName: "",
                mobileNo: "",
                workNo: "",
                emailId: "",
                registeredPassword: "",
                eSpectraCountryID: "",
                retypePassword: "",
                interest: "",
                subscription: "",
                conditionAgree: false,
                InstitutionId: "",
                InstitutionName: "",
                admin: false
            }
        }

        $scope.profileDataModel();

        var authData = AuthenticationService.getTokenInfo();
        if (authData && $rootScope.currentTab) {
            loginService.logOut();
        }
        var hideMessage = function () {
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.isModalError = false;
            $scope.isModalSuccess = false;
            $scope.message = '';
        }

        hideMessage();

        $scope.isActiveTab = function (tabIndex) {
            return tabIndex === $rootScope.currentTab
        };
        $scope.onClickTab = function (tabIndex) {

            $rootScope.currentTab = tabIndex;
            $scope.isError = false;
            $scope.isSuccess = false;
        };


        $scope.login = function () {

            if ($scope.validateLogin()) {
                progressBarService.showProgressBar();
                loginService.login($scope.loginData.userName, $scope.loginData.password).then(function (response) {

                    if (response != null && response.error != undefined) {
                        $scope.isError = true;
                        $scope.isSuccess = false;
                        $scope.message = response.error_description;
                    }
                    progressBarService.hideProgressBar();
                });
            }
        }

        $scope.validateLogin = function () {

            var returnVal = true;
            if (angular.element("#tabuserName").val() != '') {
                var emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


                if (emailregx.test(angular.element("#tabuserName").val())) {

                    $("#tabuserName").siblings("label").find("span").fadeOut();
                }
                else {

                    if (returnVal) {
                        $("#tabuserName").focus();
                    }
                    $("#tabuserName").siblings("label").find("span").fadeIn();
                    returnVal = false;
                }

            }
            else {

                if (returnVal) {
                    $("#tabuserName").focus();
                }
                $("#tabuserName").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (angular.element("#tabpassword").val() != '') {

                $("#tabpassword").siblings("label").find("span").fadeOut();
            }
            else {

                if (returnVal) {
                    $("#tabpassword").focus();
                }
                $("#tabpassword").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (!returnVal) {
                this.rLoginForm.$dirty = true;
                this.rLoginForm.password.$dirty = true;
                this.rLoginForm.userName.$dirty = true;
            }
            return returnVal;
        }

        $scope.sendResetPasswordCode = function (fieldName) {

            if ($scope.ValidateUserResetDetails(fieldName)) {
                progressBarService.showProgressBar();

                loginService.sendResetPasswordCode(angular.element("#" + fieldName).val()).then(function (response) {

                    if (response != null && response.data != null && response.data.message != undefined) {

                        $scope.message = response.data.message;
                        $scope.isError = true;
                        $scope.isSuccess = false;
                        //$timeout(hideMessage, 10000);
                    }
                    else if (response != null && response.data == null) {

                    }
                    else {

                        sendemailResetPasswordCodeNotification(response.data);
                        $("#" + fieldName).val('');
                        $("#" + fieldName).siblings("label").removeClass("active");
                        $scope.message = GetMessage.accountResetSuccessfully(response.data.eSpectraEmail);
                        $scope.isError = false;
                        $scope.isSuccess = true;
                        $rootScope.$broadcast('reloadCaptcha', {});
                        //$timeout(hideMessage, 10000);

                    }
                    progressBarService.hideProgressBar();
                });
            }
        }

        $scope.ValidateUserResetDetails = function (emailElem) {
            var returnVal = true;
            if (angular.element("#" + emailElem).val() != '') {
                var email = angular.element("#" + emailElem).val();
                var regExp = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,3}|[0-9]{1,3})(\]?)$/;

                var isValid = regExp.test(email);
                if (isValid) {
                    //$("#" + emailElem).removeClass("border-red");
                    $("#" + emailElem).siblings("label").find("span").fadeOut();
                }
                else {
                    // $("#" + emailElem).addClass("border-red");
                    if (returnVal) {
                        $("#" + emailElem).focus();
                    }
                    $("#" + emailElem).siblings("label").find("span").fadeIn();
                    returnVal = false;
                }
            }
            else {
                // $("#" + emailElem).addClass("border-red");
                if (returnVal) {
                    $("#" + emailElem).focus();
                }
                $("#" + emailElem).siblings("label").find("span").fadeIn();
                returnVal = false;
            }
            if (!$scope.captchaValid) {
                return false;
            }

            if (!returnVal) {
                this.resetForm.$dirty = true;
                this.resetForm.resetPassword.$dirty = true;
                this.resetForm.confirmPassword.$dirty = true;
            }
            return returnVal;

        }

        $scope.cancel = function () {
            $scope.loginData = {
                userName: "",
                password: ""
            };
            $scope.message = "";
            $(".input-feild-textbox").siblings("label").removeClass("active");
            $rootScope.isForgotPassword = false;
            $('form#login-nav #userName').val($('form#forgot-nav #forgotEmailId').val())
            $("form[name=forgotPasswordForm]").trigger('reset');
            $('.border-red').removeClass('border-red');
        }

        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;

        $scope.selectedInstitute = {
            InstitutionId: 0,
            InstitutionName: '',
            isAffiliationExists: false,
            userDefinedAffiliation: ''
        };

        $scope.setAffiliation = function () {

            if ($scope.selectedInstitute.InstitutionName.length > 0 || $scope.selectedInstitute.userDefinedAffiliation.length > 0) {

                $scope.profileData.InstitutionId = parseInt($scope.selectedInstitute.InstitutionId) > 0 ? $scope.selectedInstitute.InstitutionId : 0;
                $scope.profileData.InstitutionName = $scope.selectedInstitute.InstitutionName != '' ? $scope.selectedInstitute.InstitutionName : $scope.selectedInstitute.userDefinedAffiliation;

                $scope.profileForm.instituteName.$dirty = true;
                $scope.profileForm.instituteName.$touched = true;
                $scope.profileForm.instituteName.$valid = true;
                $('#institution-info').removeClass('hide');
                $('#affiliation').modal('hide');
            }
        };

        $("#instituteName").on('focusout', function () {
            $('#instituteName').typeahead('close');

            $scope.profileData.InstitutionName = $('#instituteName').val();

            $scope.$apply();
            return false;
        });

        $scope.deSelectInstitute = function () {
            $scope.profileData.InstitutionId = 1;
            $scope.profileData.InstitutionName = '';
            $scope.selectedInstitute.userDefinedAffiliation = '';
            $scope.selectedInstitute.isAffiliationExists = false;
            //$('#affiliationName').removeAttr('disabled');
            $('#institution-info').addClass('hide');

            $scope.profileForm.instituteName.$dirty = false;
            $scope.profileForm.instituteName.$untouched = true;
            $scope.profileForm.instituteName.$prestine = true;
        }

        $scope.clearAffiliationOnBackspace = function () {
            if ($('#affiliationName').val().length <= 0 && $scope.profileData.InstitutionName.length <= 0) {
                $scope.deSelectInstitute();
            }
        }

        $scope.register = function () {
            if ($scope.ValidateUserDetails()) {
                $rootScope.$broadcast('reloadCaptcha', {});
                progressBarService.showProgressBar();
                var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;

                var countryCode = $('#countryCode').parent().find('.selected-dial-code').text() + "-";
                var countryCode1 = $('#countryCode1').parent().find('.selected-dial-code').text() + "-";
                var userRegistrationInfo = {
                    eSpectraFirstName: $scope.profileData.firstName,
                    eSpectraLastName: $scope.profileData.lastName,
                    eSpectraEmail: $scope.profileData.emailId,
                    eSpectraCountryID: $scope.profileData.eSpectraCountryID,
                    eSpectraPassword: $scope.profileData.registeredPassword,
                    eSpectraPrimaryAreaOfInterest: $scope.profileData.interest,
                    eSpectraMobilePhoneNum: countryCode + $scope.profileData.mobileNo,
                    eSpectraWorkPhoneNum: countryCode1 + $scope.profileData.workNo,
                    eSpectraMktgOptInFlg: $scope.profileData.subscription ? 1 : 0,
                    eSpectraPrimaryAffiliationID: parseInt($scope.profileData.InstitutionId) > 0 ? $scope.profileData.InstitutionId : 1,
                    eSpectraPrimaryAffiliationName: $scope.profileData.InstitutionName,
                    eSpectraIsAdmin: $scope.profileData.admin ? 1 : 0,
                    InvitedEmail: $scope.InvitedEmail
                };
                loginService.register(userRegistrationInfo).then(function (response) {

                    if (response != null && response.data.message != undefined) {
                        $scope.message = response.data.message;
                        $scope.isError = true;
                        $scope.isSuccess = false;
                    }
                    else {
                        sendRegistrationNotification(userRegistrationInfo);
                        $rootScope.registrationMessage = GetMessage.accountCreatedSuccessfully(userRegistrationInfo.eSpectraEmail);
                        $location.path('/registrationsuccess');
                    }
                    progressBarService.hideProgressBar();
                });
            }
        };

        var sendRegistrationNotification = function (userRegistrationInfo) {
            loginService.sendRegistrationNotification(userRegistrationInfo);
        };


        var sendemailResetPasswordCodeNotification = function (userRegistrationInfo) {
            loginService.sendemailResetPasswordCodeNotification(userRegistrationInfo);
        };

        $scope.validatePassword = function (event) {
            commonService.validatePassword($scope, event);
        }

        $scope.ValidateUserDetails = function () {
            var returnVal = true;
            var firstName = angular.element("#firstName");
            var lastName = angular.element("#lastName");
            var email = angular.element("#inputEmailId");
            var password = angular.element("#registerPassword");
            var repeatPassword = angular.element("#repeatPassword");
            var country = angular.element("#country");
            var countryCode = angular.element("#countryCode");
            var countryCode1 = angular.element("#countryCode1");
            var rememberMe = angular.element("#rememberMe");

            if (firstName.val() != '') {
                firstName.removeClass("border-red");

                var regExp = /^([a-zA-Z]+\s?)[a-zA-Z]*$/;
                var isValid = regExp.test(firstName.val());
                if (isValid) {
                    firstName.removeClass("border-red");
                }
                else {
                    if (returnVal) {
                        firstName.focus();
                    }

                    firstName.addClass("border-red");
                    returnVal = false;
                }
            }
            else {
                if (returnVal) {
                    firstName.focus();
                }

                firstName.addClass('border-red');
                returnVal = false;
            }

            if (lastName.val() != '') {
                lastName.removeClass("border-red");

                var regExp = /^[a-zA-Z](?!.*-.*-.*)(?!.*\s.*\s.*)[a-zA-Z- ]+$/;
                var isValid = regExp.test(lastName.val());
                if (isValid) {
                    lastName.removeClass("border-red");
                }
                else {
                    if (returnVal) {
                        lastName.focus();
                    }

                    lastName.addClass('border-red')
                    returnVal = false;
                }
            }
            else {
                if (returnVal) {
                    lastName.focus();
                }

                lastName.addClass('border-red')
                returnVal = false;
            }

            if (country.val() != 1 && country.val() != "") {
                country.removeClass("border-red");

            } else {
                if (returnVal) {
                    country.focus();
                }

                country.addClass('border-red');
                returnVal = false;
            };

            if (countryCode.val() != "") {
                countryCode.removeClass("border-red");

                if (isNaN(countryCode.val())) {
                    if (returnVal) {
                        countryCode.focus();
                    }

                    countryCode.addClass("border-red");
                    countryCode.siblings('span').find("span.error-msg").addClass('display-none')
                    returnVal = false;
                } else {

                    if (countryCode.val().length >= 7 && countryCode.val().length <= 13) {
                        countryCode.removeClass("border-red");
                    } else {
                        if (returnVal) {
                            countryCode.focus();
                        }

                        countryCode.addClass("border-red");
                        returnVal = false;
                    };
                }
            };

            if (countryCode1.val() != "") {
                countryCode1.removeClass("border-red");

                if (isNaN(countryCode1.val())) {
                    if (returnVal) {
                        countryCode1.focus();
                    }

                    countryCode1.addClass("border-red");
                    countryCode1.siblings('span').find("span.error-msg").addClass('display-none')
                    returnVal = false;
                } else {

                    if (countryCode1.val().length >= 7 && countryCode1.val().length <= 13) {
                        countryCode1.removeClass("border-red");
                    } else {
                        if (returnVal) {
                            countryCode1.focus();
                        }

                        countryCode1.addClass("border-red");
                        returnVal = false;
                    };
                }
            };

            if (email.val() != '') {
                var regExp = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,3}|[0-9]{1,3})(\]?)$/;

                var isValid = regExp.test(email.val());
                if (isValid) {
                    $scope.profileData.emailId = email.val();
                    email.removeClass("border-red");
                    email.siblings('span').find("span.error-msg").addClass('display-none')
                }
                else {
                    if (returnVal) {
                        email.focus();
                    }

                    email.addClass('border-red');
                    email.siblings('span').find("span.error-msg").removeClass('display-none')
                    returnVal = false;
                }
            }
            else {
                if (returnVal) {
                    email.focus();
                }

                email.addClass('border-red');
                email.siblings('span').find("span.error-msg").removeClass('display-none');
                returnVal = false;
            }

            if (password.val() != '') {
                var regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+=-])[A-Za-z\d!@#$%^&*()_+=-]{7,20}$/;
                var isValid = regExp.test(password.val());

                if (isValid) {
                    password.removeClass("border-red");
                    if (password.val() != repeatPassword.val()) {
                        if (returnVal) {
                            repeatPassword.focus();
                        }

                        password.addClass('border-red');
                        repeatPassword.addClass('border-red');
                        returnVal = false;
                    }
                    else {
                        password.removeClass("border-red");
                        repeatPassword.removeClass("border-red");
                    }
                } else {
                    if (returnVal) {
                        password.focus();
                    }

                    password.addClass('border-red');
                    returnVal = false;
                }

            }
            else {
                if (returnVal) {
                    password.focus();
                }

                password.addClass('border-red');
                returnVal = false;
            }

            if ($scope.profileData.subscription.toString() == "") {
                $($('input[name="subRadio"]')[0]).parent('.subContainer').parent().siblings('div').find("span.error-msg").removeClass('display-none');
                if (returnVal) {
                    $($('input[name="subRadio"]')[0]).focus();
                }
                returnVal = false;
            } else {
                $($('input[name="subRadio"]')[0]).parent('.subContainer').parent().siblings('div').find("span.error-msg").addClass('display-none');
            };

            if (rememberMe[0].checked == false) {
                $scope.profileForm.conditionsAgree.$dirty = true;

                if (returnVal) {
                    rememberMe.focus();
                }
                returnVal = false;
            } else {
                $scope.profileForm.conditionsAgree.$dirty = false;
            };

            if (!$scope.captchaValid) {
                $('simple-captcha').addClass('border-all-red');
                returnVal = false;
            } else {
                $('simple-captcha').removeClass('border-all-red');
            };

            if (!($scope.PasswordLength && $scope.UpperCase && $scope.Numbers && $scope.SpecialCharacters)) {
                returnVal = false
            }

            if (!returnVal) {
                $scope.isSignupFailed = true;
                this.profileForm.$dirty = true;
                this.profileForm.firstName.$dirty = true;
                this.profileForm.lastName.$dirty = true;
                this.profileForm.inputEmailId.$dirty = true;
                this.profileForm.registerPassword.$dirty = true;
                this.profileForm.repeatPassword.$dirty = true;
            }

            return returnVal;
        }


        $scope.getcountryData = function () {
            progressBarService.showProgressBar();
            //loginService.getcountryData().then(function (response) {
            //    if (response != null && response.data.message != undefined) {
            //        $scope.message = response.data.message;
            //        $scope.isError = true;
            //        $scope.isSuccess = false;
            //    }
            //    else {
            //        progressBarService.hideProgressBar();
            //        $scope.countries = response.data;
            //        $scope.profileData.eSpectraCountryID = '1';
            //    }

            //    progressBarService.hideProgressBar();
            //});
            $http({
                method: 'Get',
                url: serviceBase + "country",
                headers: {
                    'Content-Type': 'application/json'
                }
            }).success(function (data, status) {
                if (data != null && data.message != undefined) {
                    $scope.message = data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    progressBarService.hideProgressBar();
                    $scope.countries = data;
                    $scope.profileData.eSpectraCountryID = '1';
                }
                progressBarService.hideProgressBar();
            }).error(function (data, status) {
            })

        }

        $scope.CancelRegistration = function () {
            $scope.profileDataModel();
            $("form[name=profileForm]").trigger('reset');
            $('.border-red').removeClass('border-red');
            $('#strength').hide();
            $scope.selectedInstitute.userDefinedAffiliation = '';
            $scope.selectedInstitute.isAffiliationExists = false;

            $scope.profileForm.$setPristine();
            $scope.profileForm.$setUntouched();
        }

        $scope.setTextboxStyle = function () {
            $(".input-feild-textbox").on("focusin", function () {
                $(this).parent().siblings("label").addClass("active");
                $(this).siblings("label").addClass("active");
            }).focusout(function () {
                if (!$(this).val().trim()) {
                    $(this).parent().siblings("label").removeClass("active");
                    $(this).siblings("label").removeClass("active");
                }
            });
        };

        $scope.setTextboxStyle();

        $scope.reloadCaptcha = function () {
            $rootScope.$broadcast('reloadCaptcha', {});
        }

        $scope.checkCountry = function () {
            if ($scope.profileData.eSpectraCountryID == 1 && $scope.profileForm.country.$dirty) {
                $('#country').removeClass('border-red');
            } else {
                $('#country').removeClass('border-red');
            }
        }

        $rootScope.$on('getInstituteFail', function (event, args) {
            setTimeout(function myfunction() {
                $scope.isInvalidIP = true;
                $scope.$apply();
            }, 500);
        });

        $rootScope.$on('logoutSuccess', function (event, args) {
            setTimeout(function myfunction() {
                $scope.isInvalidIP = true;
                $scope.$apply();
            }, 500);
            //window.location.reload();
        });

        $rootScope.$on('forgotPassword', function () {
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.isModalError = false;
            $scope.isModalSuccess = false;
            $scope.message = "";
        });

        if ($routeParams.userId) {
            // Registration verification
            var userId = $routeParams.userId;
            progressBarService.showProgressBar();
            $http({
                method: "POST",
                url: serviceBase + "api/Account/VerifyRegistration/" + userId,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).success(function (data, headers, status) {
                $scope.loginData.userName = data;
                localStorage.setItem("email", data);

                $scope.isError = false;
                $scope.isSuccess = true;

                $scope.message = GetMessage.accountVerifiedSuccessfully;
                //$timeout(hideMessage, 10000);
                //}
                progressBarService.hideProgressBar();
            }).error(function (data, status) {
                //if (status == "204") {
                //}
                if (data != null && data.message != undefined) {
                    $scope.message = data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                progressBarService.hideProgressBar();
            });
        } else {
            $scope.getcountryData();
        }

    }]);
    app.directive('usernameAvailable', function ($timeout, $q, $http, $rootScope) {
        return {
            restrict: 'AE',
            require: 'ngModel',
            link: function (scope, elm, attr, model) {
                model.$asyncValidators.usernameExists = function () {

                    var defer = $q.defer();
                    $timeout(function () {

                        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
                        $http.get(serviceBase + "api/Account/checkuser?username=" + model.$viewValue).then(function (res) {

                            if (res.data) {
                                elm[0].focus();
                            }

                            model.$setValidity('usernameExists', !res.data);
                            defer.resolve;
                        });


                    }, 1000);
                    return defer.promise;

                };
            }
        }
    });
})();


